
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/stellar-product-development",
      function () {
        return require("private-next-pages/services/stellar-product-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/stellar-product-development"])
      });
    }
  